<template>
	<div class="questionnaire_content">
		<div id="title">同和金属咨询工单</div>
        <div id="des">您可以填写相关信息&#10;营业部的同事将在收到意向后第一时间与您联系</div>
        <div><p class="required">*</p><p class="class">怎么称呼您</p></div>
        <input type="text" v-model="name">
        <div><p class="class">您的职位</p></div>
        <input type="text" v-model="rule">
        <div><p class="required">*</p><p class="class">您的企业/品牌名称</p></div>
        <input type="text" v-model="company_name">
        <div><p class="required">*</p><p class="class">您所在的城市</p></div>
        <input type="text" v-model="city">
        <div><p class="required">*</p><p class="class">您希望咨询的产品</p></div>
        <input type="text" v-model="product">
        <div><p class="class">您的联系方式</p></div>
        <input type="text" placeholder="请输入您的手机号" v-model="phone">
        <div><p class="required">*</p><p class="class">您的邮箱</p></div>
        <input type="text" placeholder="请输入您的邮箱" v-model="email">
        <div><p class="class">您想要咨询的问题</p></div>
        <textarea 
            rows=1
            name=s1
            cols=27
            placeholder="" 
            v-model="request_detail" 
            maxlength="200" 
            onchange="this.value=this.value.substring(0, 200);this.style.posHeight=this.scrollHeight;" 
            onkeydown="this.value=this.value.substring(0, 200);this.style.posHeight=this.scrollHeight;" 
            onkeyup="this.value=this.value.substring(0, 200);this.style.posHeight=this.scrollHeight;"
            onpropertychange= "this.style.posHeight=this.scrollHeight;console.log(123)">
        </textarea>
        <div id="commit" @click="commit">提交</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
    import store from '@/store/index.js';

	export default{
		name:"questionnaire",
		data(){
			return{
                name:'',
                rule: '',
                company_name:'',
                city:'',
                product:'',
                phone: '',
                email: '',
                request_detail:''
			}
		},

		computed:{
            fromDownload(){
                return this.$route.query.from === 'download';
            }
		},

        mounted() {
            if (this.fromDownload) {
                alert('下载资料之前请您留下您的联系方式');
            }
        },

		methods:{
            commit(){
                var self = this;
                let url = store.state.baseUrl + 'dowa/commit_quest';
                let params = {
                    'name':this.name,
                    'city':this.city,
                    'company':this.company_name,
                    'rule': this.rule,
                    'product':this.product,
                    'phone':this.phone,
                    'email': this.email,
                    'detail':this.request_detail
                };
                if (this.name == '') {
                    alert('名字不能为空')
                    return;
                }else if(this.city == ''){
                    alert('所在城市不能为空')
                    return;
                }else if(this.company_name == ''){
                    alert('企业/品牌名称不能为空')
                    return;
                }else if(this.product == ''){
                    alert('产品不能为空')
                    return;
                }else if(this.email == ''){
                    alert('联系方式不能为空')
                    return;
                }
                this.$http.post(url,params,{emulateJSON:true}).then((res)=>
                {
                    var realdata = res.data;
                    if (!realdata.success) {
                        alert(realdata.message);
                    }else{
                        localStorage.setItem('dowa_profile_quest_done', '1');
                        alert(realdata.message);
                        self.name = ''
                        self.product = ''
                        self.city = ''
                        self.phone = ''
                        self.company_name = ''
                        self.rule = ''
                        self.email = ''
                        self.request_detail = ''
                        if (self.fromDownload) {
                            self.$router.replace({ path: '/profiledownload' });
                        }
                    }
                },(err)=>
                {
                    console.log(err);
                    alert(err);
                });
            }
        },
        watch: {
            
        },
	}

</script>

<style type="text/css" scoped>
	.questionnaire_content{
        margin: 50px 30px 0 30px;
        background: rgb(249, 249, 249);
        padding: 15px;
    }
    .questionnaire_content #title{
        font-size: 30px;
        margin-bottom: 20px;
    }

    .questionnaire_content .required{
        color: red;
        display: inline-block;
    }
    .questionnaire_content .class{
        display: inline-block;
        margin: 5px;
        font-size: larger;
    }
    .questionnaire_content input{
        display: block;
        width: 100%;
        left: 15px;
        right: 30px;
        height: 40px;
        font-size: larger;
    }
    .questionnaire_content textarea{
        width: 100%;
        left: 15px;
        font-size: larger;
        overflow:auto;
        word-break:break-all;
        resize:vertical;
        height: 100px;
    }
    .questionnaire_content #des{
        white-space: pre-line;
        color: darkgray;
        font-size: 15px;
    }
    .questionnaire_content #commit{
        text-align: center;
        height: 50px;
        line-height: 50px;
        color: white;
        font-size: larger;
        background: rgb(0,166,166);
        margin-top: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/questionnaire.vue